





















































import { defineComponent } from '@nuxtjs/composition-api';
import { BaseIcon, TypeBody, TypeHeading, TypeDisplay } from '@bambeehr/pollen';
import { HeroContent } from '../constants/index';
import HomeNav from './Navigation/HomeNav.vue';
import PurpleHexContainer from '@/components/PurpleHexContainer.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt.vue';
import usePartnerPromo from '@/modules/SplashPage/hooks/usePartnerPromo';
import useRadioPromo from '@/hooks/useRadioPromo';
import { netlifyEnterTest } from '@/utils/netlifyTest';


export default defineComponent({
  name: 'HomeHero',
  components: {
    BaseIcon,
    HomeNav,
    PurpleHexContainer,
    RegistrationPrompt,
    TypeBody,
    TypeDisplay,
    TypeHeading,
  },
  props: {
    title: {
      type: String,
      default: HeroContent.title,
    },
    subtitle: {
      type: String,
      default: HeroContent.subtitle,
    },
    benefits: {
      type: Array,
      default: () => HeroContent.benefits,
    },
    promptTitle: {
      type: String,
      default: "Let's see how we can help",
    },
    promptButtonTitle: {
      type: String,
      default: 'Next',
    },
    promptDropdownLabel: {
      type: String,
      default: 'What brought you to Bambee?',
    },
  },
  setup(){
    netlifyEnterTest();
  }
});
